import React from 'react'
export enum POSITION_TYPE {
    POSITION_DELEGATED = 1,//持仓|已委托
    AVG_POSITION_PRICE = 2,//持仓均价
    BREAKEVEN_PRICE = 3,//盈亏平衡价
    MARK_PRICE = 4,//标记价格
    ESTIMATED_FORCED_PARITY_PRICE = 5,//预估强平价
    MARGIN = 6,//保证金
    MAINTENANCE_MARGIN_RATE = 7,//维持保证金率
    UNREALIZED_PROFIT_OR_LOSS = 8,//未实现盈亏(回报率)
    REALIZED_PROFIT_AND_LOSS = 9,//已实现盈亏
    PARTIAL_TAKE_PROFIT_AND_STOP_LOSS = 10,//部分止盈止损
    MOVING_TAKE_PROFIT_AND_STOP_LOSS = 11,//移动止盈止损
    MMR_STOP_LOSS= 12,//MMR止损
    BACKHAND = 13,//反手
    MOVINGTAKEPROFIT_AND_STOP_LOSS_BTN = 14 // 全部止盈止损
}
export const getPostionText = (type,t):string=>{
    const positon_show = {
        [POSITION_TYPE.POSITION_DELEGATED]:`${t('position_block_text.position_size','Position')}| ${t('position_block_text.position_close_locked','Open orders')}`,
        [POSITION_TYPE.AVG_POSITION_PRICE]: `${t('position_block_text.position_entry_price','Average price')}`,
        [POSITION_TYPE.BREAKEVEN_PRICE]: `${t('order_opt.break_even_price','Break even price')}`,
        [POSITION_TYPE.MARK_PRICE]: `${t('position_mark_price','Mark price')}`,
        [POSITION_TYPE.ESTIMATED_FORCED_PARITY_PRICE]: `${t('position_block_text.position_liq_price','Est. liq. price')}`,
        [POSITION_TYPE.MARGIN]: `${t('position_block_text.position_margin','Margin')}`,
        [POSITION_TYPE.MAINTENANCE_MARGIN_RATE]: `${t('position_block_text.position_maintain_rate','Risk rate')}`,
        [POSITION_TYPE.UNREALIZED_PROFIT_OR_LOSS]:`${t('position_block_text.position_unrealised_pnl','Unrealized PnL')}`,
        [POSITION_TYPE.REALIZED_PROFIT_AND_LOSS]: `${t('position_block_text.position_realised_pnl','Realized PnL')}`,
        [POSITION_TYPE.PARTIAL_TAKE_PROFIT_AND_STOP_LOSS]: `${t('order_opt.partial_pos_tpsl','Realized PnL')}`,
        [POSITION_TYPE.MOVING_TAKE_PROFIT_AND_STOP_LOSS]: `${t('order_opt.move_tpsl','Take Profit stop')}`,
        [POSITION_TYPE.MMR_STOP_LOSS]:`${t('track_order.MMR_stop_loss_title','MMR loss')}`,
        [POSITION_TYPE.BACKHAND]: `${t('position_block_text.position_close_reverse','Close reverse')}`,
        [POSITION_TYPE.MOVINGTAKEPROFIT_AND_STOP_LOSS_BTN]:`${t('order_list_text.option_all_tpsl','Option all tpsl')}`,
      }
      return positon_show[type]
}
interface Props {
    type:number,
    item:object
}
export const getPostionKey = (type,item)=>{
    const positon_show = {
        [POSITION_TYPE.POSITION_DELEGATED]:'',
        [POSITION_TYPE.AVG_POSITION_PRICE]: '',
        [POSITION_TYPE.BREAKEVEN_PRICE]: '',
        [POSITION_TYPE.MARK_PRICE]: '',
        [POSITION_TYPE.ESTIMATED_FORCED_PARITY_PRICE]: '',
        [POSITION_TYPE.MARGIN]: '',
        [POSITION_TYPE.MAINTENANCE_MARGIN_RATE]: '',
        [POSITION_TYPE.UNREALIZED_PROFIT_OR_LOSS]: '',
        [POSITION_TYPE.REALIZED_PROFIT_AND_LOSS]: '',
        [POSITION_TYPE.PARTIAL_TAKE_PROFIT_AND_STOP_LOSS]: '',
        [POSITION_TYPE.MOVING_TAKE_PROFIT_AND_STOP_LOSS]: '',
        [POSITION_TYPE.MMR_STOP_LOSS]: '',
        [POSITION_TYPE.BACKHAND]: '',
        [POSITION_TYPE.MOVINGTAKEPROFIT_AND_STOP_LOSS_BTN]:''
      }
      return positon_show[type]
}
export enum StatusType {
    OPEN = 1,//开
    CLOSE = 0 //关
}
export interface sortType{
    type:POSITION_TYPE,
    status:StatusType
}
export const initData = [
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.POSITION_DELEGATED]
    },
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.AVG_POSITION_PRICE]
    },
    {
      "status": StatusType.CLOSE,
      "type": [POSITION_TYPE.BREAKEVEN_PRICE]
    },
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.MARK_PRICE]
    },
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.ESTIMATED_FORCED_PARITY_PRICE]
    },
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.MARGIN]
    },
    {
      "status": StatusType.CLOSE,
      "type": [POSITION_TYPE.MAINTENANCE_MARGIN_RATE]
    },
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.UNREALIZED_PROFIT_OR_LOSS]
    },
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.REALIZED_PROFIT_AND_LOSS]
    },
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.MOVINGTAKEPROFIT_AND_STOP_LOSS_BTN]
    },
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.PARTIAL_TAKE_PROFIT_AND_STOP_LOSS]
    },
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.MOVING_TAKE_PROFIT_AND_STOP_LOSS]
    },
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.MMR_STOP_LOSS]
    },
    {
      "status": StatusType.OPEN,
      "type": [POSITION_TYPE.BACKHAND]
    }
  ]